import { Component, OnInit, Input } from '@angular/core';
import { Pick } from '../../core/models/cart/pick.model';
import { Real } from '../../core/models/real.model';

@Component({
  selector: 'app-party-size-popover',
  templateUrl: './party-size-popover.component.html',
  styleUrls: ['./party-size-popover.component.scss'],
})
export class PartySizePopoverComponent implements OnInit {

  @Input() pick: Pick;
  @Input() real: Real;

  constructor() { }

  ngOnInit() {}

}
